import type { ServiceItem } from '@/cms/fields/types/checkout-page'
import { isEmpty } from 'ramda'
import * as React from 'react'
import { useIntl } from '@/intl'
import { CheckoutSection } from '@/scopes/checkout/components/CheckoutSection'
import { getIconForService } from '@/scopes/checkout/components/ServiceIcon'
import { useSendAncillaryAvailable } from '@/scopes/checkout/domain/analytics/useSendAncillaryAvailable'
import { useService } from '@/scopes/checkout/domain/hooks'
import { GOLF_NEW_SLOT_KEY, ServiceType } from '@/scopes/checkout/domain/types'
import styles from './GolfService.module.css'
import { GolfServiceSlot } from './GolfServiceSlot'

export function GolfService({ item }: { item: ServiceItem }) {
  const intl = useIntl()
  const { service } = useService(ServiceType.Golf)
  const { componentTitle, componentDescription, popupTitle, popupDescription, popupReadMoreLabel } = item

  useSendAncillaryAvailable(service, 'selectGolf')

  if (!service)
    return null

  const { participants, options, selectedValues } = service

  if (isEmpty(options))
    return null

  const savedSlotIds = Object.keys(selectedValues)

  return (
    <CheckoutSection
      title={componentTitle || intl.formatMessage({ id: 'checkout_steps_ancillaries_golf_title' })}
      description={componentDescription}
      glyph={getIconForService(ServiceType.Golf)}
      moreInformationTitle={popupTitle}
      moreInformationDescription={popupDescription}
      moreInformationReadMoreLabel={popupReadMoreLabel}
    >
      <div className={styles.slots}>
        {savedSlotIds.map(slotId => (
          <GolfServiceSlot key={slotId} slotId={slotId} />
        ))}
        {!isEmpty(participants) && (
          <GolfServiceSlot key={GOLF_NEW_SLOT_KEY} slotId={GOLF_NEW_SLOT_KEY} />
        )}
      </div>
    </CheckoutSection>
  )
}
